export default "__VITE_PUBLIC_ASSET__68f99260__"